// AR
export const derivedRatesSection = {
  title: "الأسعار المشتقة",
  description:
    "أنشئ أسعارًا مبنية على خطط الأسعار الرئيسية للاتصال بمختلف وكالات السفر عبر الإنترنت (OTA) مع الحفاظ على سعر أساسي مركزي.",
  newRate: "سعر مشتق جديد",
  loading: "جارٍ تحميل الأسعار...",

  otaBadge: "OTA",
  otaLockedTitle: "سعر خاص بوكالة سفر عبر الإنترنت: تتم إدارته من 'ربط OTA'",
  salePaused: "البيع متوقف",

  columns: {
    name: "الاسم",
    adjustment: "التعديل",
    finalPrice: "السعر النهائي",
  },

  actions: {
    resumeTitle: "استئناف البيع في Channex",
    pauseTitle: "إيقاف البيع في Channex (stop_sell)",
    edit: "تعديل",
    delete: "حذف",
    protectedTitle: "محمي: غيّره أو أزله من 'ربط OTA'",
  },

  empty: {
    title: "لا توجد أسعار مشتقة",
    text: "أنشئ أسعارًا مشتقة مبنية على خطط الأسعار الرئيسية للاتصال بوكالات السفر عبر الإنترنت",
    create: "إنشاء أول سعر مشتق",
  },

  modal: {
    editTitle: "تعديل السعر المشتق",
    createTitle: "سعر مشتق جديد",
    baseRatePlan: "خطة السعر الأساسية",
    selectBasePlaceholder: "اختر خطة سعر أساسية",
    selectBaseHint: "اختر خطة السعر التي سيُحتسب على أساسها هذا السعر المشتق",
    nameLabel: "اسم السعر المشتق",
    namePlaceholder: "مثال: سعر Booking.com، سعر Airbnb",
    nameHint: "سيساعدك هذا الاسم على تمييز السعر عند الاتصال بوكالات السفر عبر الإنترنت",
    adjustmentType: "نوع التعديل",
    percentage: "نسبة مئوية",
    fixedAmount: "مبلغ ثابت",
    adjustmentValue: "قيمة التعديل",
    adjustmentValueHint: "(استخدم قيمًا سالبة للخصومات)",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ...",
    update: "تحديث",
    create: "إنشاء السعر",
  },

  preview: {
    title: "معاينة",
    basePrice: "السعر الأساسي",
    increment: "زيادة",
    discount: "خصم",
    finalPrice: "السعر النهائي",
  },

  delete: {
    title: "حذف السعر المشتق",
    warnStrong: "لا يمكن التراجع عن هذا الإجراء.",
    warnText: "قبل الحذف، تأكد من أن السعر {name} غير مرتبط بأي وكالة سفر عبر الإنترنت.",
    confirmLabel: "اكتب الاسم بالضبط للتأكيد:",
    confirmPlaceholder: "اكتب اسم السعر بالضبط",
    confirmHint: "الصق أو اكتب الاسم تمامًا كما يظهر أعلاه لتفعيل زر الحذف.",
    cancel: "إلغاء",
    processing: "جارٍ الحذف...",
    confirm: "حذف نهائي",
  },

  pause: {
    resumeTitle: "استئناف البيع",
    pauseTitle: "إيقاف البيع",
    resumeText:
      "سيُرسَل {code} إلى Channex لمدة الـ500 يوم القادمة. ستعود القناة إلى استقبال الإتاحة وستتمكن من قبول الحجوزات.",
    pauseText:
      "سيُرسَل {code} إلى Channex لمدة الـ500 يوم القادمة. لن تتمكن القناة المرتبطة بهذا السعر من قبول حجوزات جديدة أثناء الإيقاف.",
    note: "لن يتأثر التقويم الرئيسي والقنوات الأخرى. للاستئناف، انقر على زر ▶ الخاص بالسعر.",
    cancel: "إلغاء",
    resuming: "جارٍ الاستئناف...",
    pausing: "جارٍ الإيقاف...",
    confirmResume: "نعم، استئناف البيع",
    confirmPause: "نعم، إيقاف البيع",
  },

  toast: {
    loadError: "خطأ في تحميل البيانات",
    fillRequired: "يرجى إكمال جميع الحقول المطلوبة",
    updated: "تم تحديث السعر بنجاح",
    created: "تم إنشاء السعر بنجاح",
    saveFailed: "تعذّر حفظ السعر",
    saveError: "خطأ في حفظ السعر المشتق",
    deleted: "تم حذف السعر المشتق",
    deleteFailed: "تعذّر حذف السعر",
    deleteLinkedOta: "لا يمكن الحذف: السعر مرتبط بوكالة سفر عبر الإنترنت.",
    nameMismatch: "الاسم المُدخَل غير مطابق.",
    deleteError: "خطأ في حذف السعر المشتق",
    salesPaused: "تم إيقاف البيع",
    salesResumed: "تم استئناف البيع",
    toggleFailed: "تعذّر تغيير الحالة",
    toggleError: "خطأ في تغيير حالة السعر",
    // Guardada en local, pero Channex no aceptó el cambio (channex_synced:false).
    channexNotSynced: "تم حفظ السعر، لكن مدير القنوات لم يقبل التغيير: ما زالت القنوات على الإعداد السابق. راجع البيانات وحاول مرة أخرى.",
  },

  // Estancia mínima propia de una derivada (own_min_stay). Campo y chip
  // compartidos: OwnMinStayField.vue / OwnMinStayChip.vue.
  ownMinStay: {
    label: "الحد الأدنى الخاص للإقامة (ليالٍ)",
    hint: "فارغ = نفس الحد الخاص بالسعر الرئيسي",
    mixedPlaceholder: "متعدد",
    mixedHint: "لكل غرفة حد أدنى مختلف. إذا كتبت قيمة فستُطبَّق على الجميع؛ وإذا تركته فارغًا فستحتفظ كل غرفة بحدها.",
    // Sugerencia por el nombre («Tarifa semanal» → 7): una pregunta de un clic.
    suggestQuestion: "حد أدنى {n} ليلة؟ | حد أدنى {n} ليالٍ؟",
    suggestUse: "استخدام",
    clear: "إزالة",
    channelNote: "ستستلم {channel} حدًا أدنى قدره {n} ليلة لهذا السعر. | ستستلم {channel} حدًا أدنى قدره {n} ليالٍ لهذا السعر.",
    genericNote: "ستستلم القنوات المتصلة (Booking وغيرها) حدًا أدنى قدره {n} ليلة لهذا السعر. | ستستلم القنوات المتصلة (Booking وغيرها) حدًا أدنى قدره {n} ليالٍ لهذا السعر.",
    chip: "حد أدنى {n} ليلة | حد أدنى {n} ليالٍ",
    chipMixed: "حد أدنى مختلف لكل غرفة",
    chipTitle: "الحد الأدنى الخاص للإقامة لهذا السعر: يُرسَل إلى القنوات المتصلة",
    // Grupo con mínimos distintos: quitárselo a todas es un gesto aparte.
    clearAll: "إزالة الحد الأدنى من الجميع",
    clearedAllHint: "عند الحفظ، ستفقد جميعها حدها الأدنى الخاص وستستخدم حد السعر الرئيسي.",
    undo: "تراجع",
  },
};
